t = require('app/scripts/views/internal/teacup-with-helpers')('actions_empty')

module.exports = ->
  t.p '.empty-list', ->
    t.mustacheBlock 'daysBack', ->
      t.format 'no-actions-in-the-last-daysback-days', { daysBack: t.mustacheVar('daysBack') }
    t.mustacheBlockInverted 'daysBack', ->
      t.format 'no-actions'
